import React from 'react';

const fmtTime = (d) => {
  const dt = new Date(d);
  const now = new Date();
  const isToday = dt.toDateString() === now.toDateString();
  const isYesterday = dt.toDateString() === new Date(Date.now() - 86400000).toDateString();
  const time = dt.toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' });
  if (isToday) return 'Oggi ' + time;
  if (isYesterday) return 'Ieri ' + time;
  return dt.toLocaleDateString('it-IT', { day: 'numeric', month: 'short' });
};

const TIPO_TO_TAB = {
  documento: 'documenti',
  fattura: 'fatture',
  vocale: 'report',
  task: 'piano',
  fase: 'piano',
  costo: 'spese',
};

export default function CantiereActivityFeed({ feed, onViewAll, onNavigateTab }) {
  if (!feed || feed.length === 0) {
    return (
      <div style={{ padding: 20, color: 'var(--ds-muted)', fontSize: 13 }}>
        Nessuna attività recente.
      </div>
    );
  }

  return (
    <div style={{
      border: '1px solid var(--ds-border)', borderRadius: 'var(--radius-card)',
      background: 'var(--chip)', overflow: 'hidden',
    }}>
      {/* Header */}
      <div style={{
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        padding: '12px 16px', borderBottom: '1px solid var(--ds-border)',
      }}>
        <div style={{ fontSize: 13, fontWeight: 500, textTransform: 'uppercase', color: 'var(--ds-text)' }}>
          📅 Attività recenti
        </div>
        {onViewAll && (
          <button onClick={onViewAll} style={{
            border: 'none', background: 'none', cursor: 'pointer',
            fontSize: 12, color: 'var(--brand)',
          }}>
            Vedi tutte
          </button>
        )}
      </div>

      {/* Items */}
      {feed.map((item, i) => {
        const targetTab = TIPO_TO_TAB[item.tipo];
        const isClickable = targetTab && onNavigateTab;
        return (
          <div key={i}
            onClick={() => { if (isClickable) onNavigateTab(targetTab); }}
            style={{
              display: 'flex', alignItems: 'flex-start', gap: 12,
              padding: '12px 16px',
              borderBottom: i < feed.length - 1 ? '1px solid var(--ds-border)' : 'none',
              cursor: isClickable ? 'pointer' : 'default',
              transition: 'background 0.1s ease',
            }}
            onMouseEnter={e => { if (isClickable) e.currentTarget.style.background = 'var(--chip)'; }}
            onMouseLeave={e => { e.currentTarget.style.background = ''; }}
          >
            <span style={{
              width: 36, height: 36, borderRadius: '50%',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 16, flexShrink: 0,
              background: item.colore || 'var(--chip)',
            }}>
              {item.icona}
            </span>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 13, color: 'var(--ds-text)' }}>
                <span style={{ fontWeight: 500 }}>
                  {(item.titolo || item.descrizione || '').split(' — ')[0]}
                </span>
                {(item.titolo || item.descrizione || '').includes(' — ') && (
                  <span style={{ fontWeight: 400 }}>
                    {' — ' + (item.titolo || item.descrizione || '').split(' — ').slice(1).join(' — ')}
                  </span>
                )}
              </div>
              <div style={{ fontSize: 11, color: 'var(--ds-muted)', marginTop: 3 }}>
                {fmtTime(item.data)}
                {item.sottotitolo && (' · ' + item.sottotitolo)}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
